import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import theme from './theme'
import '@mdi/font/css/materialdesignicons.css'
import ar from 'vuetify/es5/locale/ar'
import '../styles/index.scss'
Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { ar },
    current: 'ar',
  },
  theme,
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
  }),
});
